import { type FC } from 'react'
import { useSearchBox, type UseSearchBoxProps } from 'react-instantsearch'

export const ProductSearchVirtualWidgetSearchBox: FC<UseSearchBoxProps> = (
  props,
) => {
  useSearchBox(props)

  return null
}
